/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Noattemptsrecorded2Inputs */

const zh_learn_noattemptsrecorded2 = /** @type {(inputs: Learn_Noattemptsrecorded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个学习资源还没有任何作答记录。`)
};

const en_learn_noattemptsrecorded2 = /** @type {(inputs: Learn_Noattemptsrecorded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No attempts recorded for this resource yet.`)
};

const es_learn_noattemptsrecorded2 = /** @type {(inputs: Learn_Noattemptsrecorded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay intentos registrados para este recurso.`)
};

/**
* | output |
* | --- |
* | "No attempts recorded for this resource yet." |
*
* @param {Learn_Noattemptsrecorded2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_noattemptsrecorded2 = /** @type {((inputs?: Learn_Noattemptsrecorded2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Noattemptsrecorded2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_noattemptsrecorded2(inputs)
	if (locale === "en") return en_learn_noattemptsrecorded2(inputs)
	return es_learn_noattemptsrecorded2(inputs)
});
export { learn_noattemptsrecorded2 as "learn_noAttemptsRecorded" }